import { api, apiClient } from "aaa";
import { observable, action } from "mobx";
import { create, persist } from "mobx-persist";

export class Auth {
    @persist("object") @observable token: api.IAuthToken | undefined;
    @persist("object") @observable isAdmin: boolean = false;

    @observable isRehydrated: boolean = false;
    @observable isLoading = false;

    /**
     * Authenticate user with token
     */
    @action tokenExchange = async () => {
        if (!this.token) {
            return;
        }

        try {
            this.isLoading = true;
            const request = api.tokenRefresh(this.token.refreshToken);
            this.token = await apiClient.requestType(request);
            this.isLoading = false;
        } catch (e) {
            this.isLoading = false;
            this.token = undefined;
        }
    }

    @action logout() {
        this.token = undefined;
        this.isAdmin = false;
    }
}

export const auth = new Auth();

// persist this mobx state through localforage
const hydrate = create({
    storage: require("localforage")
});


hydrate("auth", auth).then(async () => {
    await auth.tokenExchange();
    auth.isRehydrated = true;
}).catch((error: any) => {
    console.error(error);
    auth.isRehydrated = true;
});



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/models/Auth.ts